import React, { useState, useEffect, useRef } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  Modal,
  Box,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { GoSearch } from "react-icons/go";
import { axiosInstance } from "../../axiosInstance";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const columns = [
  { id: "vehicle_type", label: "VEHICLE TYPE", minWidth: 170, align: "center" },
  { id: "city", label: "CITY", minWidth: 100, align: "center" },
  {
    id: "radius_from_retailer",
    label: "CITY RADIUS",
    minWidth: 170,
    align: "center",
  },
  {
    id: "gomak_commision",
    label: "GOMAK COMMISSION",
    minWidth: 170,
    align: "center",
  },
  { id: "ryder_gst", label: "RYDER GST", minWidth: 170, align: "center" },
  { id: "gomak_gst", label: "GOMAK GST", minWidth: 170, align: "center" },
  { id: "status", label: "STATUS", minWidth: 170, align: "center" },
  {
    id: "gomakcash_active",
    label: "GOMAK CASH STATUS",
    minWidth: 170,
    align: "center",
  },
  {
    id: "charge_per_km",
    label: "CHARGE PER KM",
    minWidth: 170,
    align: "center",
  },
  // { id: "is_active", label: "Is Active", minWidth: 170, align: "center" },
  { id: "actions", label: "ACTIONS", minWidth: 100, align: "center" },
];

function createData(
  vehicle_type,
  city,
  radius_from_retailer,
  gomak_commision,
  ryder_gst,
  gomak_gst,
  status,
  charge_per_km,
  // is_active
) {
  return {
    vehicle_type,
    city,
    radius_from_retailer,
    gomak_commision,
    ryder_gst,
    gomak_gst,
    status,
    charge_per_km,
    // is_active,
  };
}

const rows = [
  createData("Hyderabad", "5 km", "Active", "₹ 10.00"),
  createData("Hyderabad", "5 km", "Active", "₹ 10.00"),
  createData("Chennai", "2 km", "Inactive", "₹ 10.00"),
  createData("Hyderabad", "5 km", "Active", "₹ 10.00"),
  createData("Hyderabad", "5 km", "Active", "₹ 10.00"),
  createData("Chennai", "2 km", "Inactive", "₹ 10.00"),
];

export const RyderZone = () => {
  const [ryderZoneList, setRyderZoneList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [toggleModalOpen, setToggleModalOpen] = useState(false);
  const [toggleTarget, setToggleTarget] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();

  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(10);

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  const fetchRyderZone = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get("/admin/ryder-zones/");
      console.log("✅ RyderZone list response:", res.data);
      if (res.data.status === "success") {
        setRyderZoneList(res.data.data || []);
      } else {
        setError("Failed to fetch RyderZone data.");
      }
    } catch (err) {
      console.error("❌ Error fetching RyderZone data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRyderZone();
  }, []);

  const openToggleModal = (row) => {
    setToggleTarget(row);
    setToggleModalOpen(true);
  };

  const handleToggleStatus = async () => {
    if (!toggleTarget) return;
    try {
      const res = await axiosInstance.patch(
        `/admin/ryder-zones/${toggleTarget.id}/`,
        {
          // is_active: !toggleTarget.is_active,
          is_enabled: !toggleTarget.is_enabled,
        },
      );
      if (res.data.status === "success") {
        toast.success("Status updated successfully");
        fetchRyderZone();
      } else {
        toast.error("Failed to update status");
      }
    } catch (err) {
      toast.error("Error updating status");
    } finally {
      setToggleModalOpen(false);
    }
  };

  const filteredData = ryderZoneList.filter((row) => {
    const query = searchQuery.toLowerCase();
    return row.city?.toLowerCase().includes(query);
  });

  // save table page size in local to save data on page change
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem("ryderZone_page");
    return savedPage ? Number(savedPage) : 0;
  });

  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const savedRows = localStorage.getItem("ryder_rowsPerPage");
    return savedRows ? Number(savedRows) : 20;
  });
  const pageChangedByUser = useRef(false);

  const handleChangePage = (event, newPage) => {
    pageChangedByUser.current = true;
    setPage(newPage);
    localStorage.setItem("ryderZone_page", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = Number(event.target.value);
    pageChangedByUser.current = true;

    setRowsPerPage(value);
    setPage(0);

    localStorage.setItem("ryder_rowsPerPage", value);
    localStorage.setItem("ryderZone_page", 0);
  };

  // Reset page on search and filters

  useEffect(() => {
    if (loading) return;

    // Do NOT reset page on refresh
    if (!pageChangedByUser.current) return;

    const maxPage = Math.max(
      0,
      Math.ceil(filteredData.length / rowsPerPage) - 1,
    );

    if (page > maxPage) {
      setPage(0);
      localStorage.setItem("ryderZone_page", 0);
    }
  }, [filteredData.length, rowsPerPage, loading, page]);

  return (
    <>
      <div>
        <div className="admin-top-container">
          <div className="admin-listText">Ryder Zone</div>
          {/* <div>
            <select className="listAdmin-showRecords">
              <option>Show No of Records</option>
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
            </select>
          </div> */}
          <div className="search-container">
            <div className="nav-search ">
              <span className="search-icons">
                <GoSearch />
              </span>
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
          <div className="btnAdd">
            <button onClick={() => navigate("/ryder-zone-add")}>
              + Add Ryder Zone
            </button>
          </div>
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : filteredData.length > 0 ? (
                  filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        className="table-row"
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                        sx={{
                          backgroundColor:
                            index % 2 === 1 ? "#E7F0F9" : "white",
                        }}
                      >
                        {columns.map((column) => {
                          let value = row[column.id];
                          const displayValue =
                            value === null ||
                            value === undefined ||
                            value === ""
                              ? "--"
                              : value;

                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              className={`${column.id}-column tableCelldata`}
                              // sx={{
                              //   color:
                              //     column.id === "status"
                              //       ? row.is_active
                              //         ? "green"
                              //         : "red"
                              //       : "inherit",
                              // }}
                              sx={{
                                color:
                                  column.id === "status"
                                    ? row.is_enabled
                                      ? "green"
                                      : "red"
                                    : column.id === "gomakcash_active"
                                      ? row.gomakcash_active === true
                                        ? "green"
                                        : "red"
                                      : "inherit",
                              }}
                            >
                              {column.id === "actions" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <IconButton sx={{ color: "black" }}>
                                    <EditIcon
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "18px",
                                      }}
                                      onClick={() =>
                                        navigate(`/ryder-zone-edit/${row.id}`)
                                      }
                                    />
                                  </IconButton>
                                  {/* <IconButton
                                  sx={{ color: "black" }}
                                  onClick={() =>
                                    handleOpenDeleteModal(row.id)
                                  }
                                >
                                  <DeleteIcon style={{ fontSize: "18px" }} />
                                </IconButton> */}
                                  <div
                                    className="form-check form-switch"
                                    style={{ marginTop: "5px" }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`toggleSwitch-${row.id}`}
                                      // checked={row.is_active}
                                      checked={row.is_enabled}
                                      onChange={() => openToggleModal(row)}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`toggleSwitch-${row.id}`}
                                    ></label>
                                  </div>
                                </div>
                              ) : // : column.id === "is_active" ? (
                              //   <select
                              //     className="yesDropdown"
                              //     value={row.is_active ? "Yes" : "No"}
                              //     disabled
                              //   >
                              //     <option value="Yes">Yes</option>
                              //     <option value="No">No</option>
                              //   </select>
                              // )
                              column.id === "status" ? (
                                // row.is_active ? (
                                //   "Active"
                                // ) : (
                                //   "Inactive"
                                // )
                                row.is_enabled ? (
                                  "Enabled"
                                ) : (
                                  "Disabled"
                                )
                              ) : column.id === "gomakcash_active" ? (
                                row.gomakcash_active ? (
                                  "Active"
                                ) : (
                                  "Inactive"
                                )
                              ) : column.id === "charger_per_km" ? (
                                `₹ ${Number(row.charger_per_km).toFixed(2)}`
                              ) : column.id === "radius_from_retailer" ? (
                                `${Number(row.radius_from_retailer)} KM `
                              ) : column.id === "charge_per_km " ? (
                                `${Number(row.charge_per_km).toFixed(2)}`
                              ) : column.id === "gomak_commision" ? (
                                `${Number(row.gomak_commision).toFixed(2)} %`
                              ) : column.id === "ryder_gst" ? (
                                `${Number(row.ryder_gst).toFixed(2)} %`
                              ) : column.id === "gomak_gst" ? (
                                `${Number(row.gomak_gst).toFixed(2)} %`
                              ) : (
                                displayValue
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={columns.length}
                      align="center"
                      style={{ padding: "40px 0" }}
                    >
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>

      {/* Toggle Status Modal */}
      {/* Active or InActive Confirmation Modal */}

      <Modal
        open={toggleModalOpen}
        onClose={() => setToggleModalOpen(false)}
        aria-labelledby="toggle-status-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <h3 id="toggle-status-title">Are you sure?</h3>
          <hr />
          <p>
            {/* Do you want to {toggleTarget?.is_active ? "INACTIVATE" : "ACTIVATE"}{""} */}
            Do you want to {toggleTarget?.is_enabled ? "DISABLE" : "ENABLE"}{" "}
            {""}
            this RyderZone?
          </p>
          <hr />
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <Button
              onClick={() => setToggleModalOpen(false)}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={handleToggleStatus}
              variant="contained"
              color="primary"
            >
              Confirm
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};
